export const BASE_URL = `${process.env.CALENDAR_APP_URL}:3443/api`;
// export const BASE_URL = 'http://localhost:8081/api';
// export const BASE_URL = 'https://calendar.relex.ru:3443/api'; //Прод-стенд